import config from '@/config/index';

/**
     * 增加服务
     *
     * @param serviceName        服务名称
     * @param serviceCategory    服务分类
     * @param industryCategory   服务领域
     * @param orgid              机构id
     * @param uploadUid          上传者ID
     * @param serviceDescription 详情及描述
     * @param amountlower        金额下限
     * @param amountupper        金额上限
     * @param nonamount          金额面议
     * @param img                图片
     * @param contacts           联系人
     * @param mobile             手机号
     * @param show               显示
     * @param request
     * @return
     */
function addService() {
    return `${config.HOST_API}${config.BASE_API_PREFIX}/service`;
}

function modifyService() {
    return `${config.HOST_API}${config.BASE_API_PREFIX}/modifyservice`;
}

/**
     * @param sid     服务id
     * @param request
     * @return
     */
function deleteService() {
    return `${config.HOST_API}${config.BASE_API_PREFIX}/deleteservice`;
}

/**
   * @param sid     服务ID
   * @return
   */
function getServiceById(sid) {
    return `${config.HOST_API}${config.BASE_API_PREFIX}/service/${sid}`;
}

/**
   * @param orgid 机构ID
   * @return
   */
function getServicesByOrgid(orgid) {
    return `${config.HOST_API}${config.BASE_API_PREFIX}/servicesbyorgid/${orgid}`;
}



export {
    addService,
    modifyService,
    deleteService,
    getServiceById,
    getServicesByOrgid
};
